"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../config/wagtailConfig");
var Button_1 = __importDefault(require("../../components/Button/Button"));
var Icon_1 = __importDefault(require("../../components/Icon/Icon"));
var SelectLocale = function (_a) {
    var locale = _a.locale, translations = _a.translations, gotoPage = _a.gotoPage;
    var options = wagtailConfig.LOCALES
        .filter(function (_a) {
        var code = _a.code;
        return code === locale || translations.get(code);
    })
        /* eslint-disable-next-line camelcase */
        .map(function (_a) {
        var code = _a.code, display_name = _a.display_name;
        return react_1["default"].createElement("option", { key: code, value: code }, display_name);
    });
    var onChange = function (e) {
        e.preventDefault();
        var translation = translations.get(e.target.value);
        if (translation) {
            gotoPage(translation, 0);
        }
    };
    return (react_1["default"].createElement("div", { className: "c-page-explorer__header__select" },
        react_1["default"].createElement("select", { value: locale, onChange: onChange, disabled: options.length < 2 }, options),
        react_1["default"].createElement("span", null)));
};
/**
 * The bar at the top of the explorer, displaying the current level
 * and allowing access back to the parent level.
 */
var PageExplorerHeader = function (_a) {
    var page = _a.page, depth = _a.depth, onClick = _a.onClick, gotoPage = _a.gotoPage, navigate = _a.navigate;
    var isRoot = depth === 0;
    var isSiteRoot = page.id === 0;
    return (react_1["default"].createElement("div", { className: "c-page-explorer__header" },
        react_1["default"].createElement(Button_1["default"], { href: !isSiteRoot ? "" + wagtailConfig_1.ADMIN_URLS.PAGES + page.id + "/" : wagtailConfig_1.ADMIN_URLS.PAGES, className: "c-page-explorer__header__title", onClick: onClick, navigate: navigate },
            react_1["default"].createElement("div", { className: "c-page-explorer__header__title__inner" },
                react_1["default"].createElement(Icon_1["default"], { name: isRoot ? 'home' : 'arrow-left', className: "icon--explorer-header" }),
                react_1["default"].createElement("span", null, page.admin_display_title || wagtailConfig_1.STRINGS.PAGES))),
        !isSiteRoot && page.meta.locale &&
            page.translations &&
            page.translations.size > 0 &&
            react_1["default"].createElement(SelectLocale, { locale: page.meta.locale, translations: page.translations, gotoPage: gotoPage })));
};
exports["default"] = PageExplorerHeader;
